module.exports = "\n<div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 row-top\" *ngFor=\"let item of upload_links; let i = index\">\n        <a target=\"_blank\" href=\"{{item}}\">\n          <img class=\"img-fluid\" src=\"{{getFileThumail(item)}}\" />\n          <span class=\"txtwarp\">{{getFileNameSplit(item)}}</span>\n        </a>\n      </div>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/sub-component/common/common-attach-browse/common-attach-browse.component.html
// module id = ./src/app/seller/sub-component/common/common-attach-browse/common-attach-browse.component.html
// module chunks = main